import api from '../../api/_patient'

const state = () => ({
    patient: [],
    patients: [],
    historiques: [],
    resultats: [],
    info_patient: [],
    info_assure_principal: [],
})

// getters
const getters = {
    patient: (state) => {
        return state.patient;
    },
    patients: (state) => {
        return state.patients;
    },
    historiques: (state) => {
        return state.historiques;
    },

    resultats: (state) => {
        return state.resultats;
    },

    info_patient: (state) => {
        return state.info_patient;
    },

    info_assure_principal: (state) => {
        return state.info_assure_principal;
    },
};

// mutations
const mutations = {
    SET_PATIENTS(state, patients) {
        state.patients = patients
    },

    SET_PATIENT(state, patient) {
        state.patient = patient
    },

    SET_HISTORIQUES(state, historiques) {
        state.historiques = historiques
    },

    SET_RESULTATS(state, resultats) {
        state.resultats = resultats
    },

    SET_INFO_PATIENT(state, patient) {
        state.info_patient = patient
    },

    SET_INFO_ASSURE_PRINCIPAL(state, assure) {
        state.info_assure_principal = assure
    },
}

// actions
const actions = {
    getPatients({ commit }) {
        return new Promise((resolve, reject) => {
            api.patients().then(
                (response) => {
                    commit("SET_PATIENTS", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getInfoPatient({ commit }, patient_id) {
        return new Promise((resolve, reject) => {
            api.getInfoPatient(patient_id).then(
                (response) => {
                    commit("SET_INFO_PATIENT", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getInfoAssurePrincipal({ commit }, patient_id) {
        return new Promise((resolve, reject) => {
            api.getInfoAssurePrincipal(patient_id).then(
                (response) => {
                    commit("SET_INFO_ASSURE_PRINCIPAL", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getPatient({ commit }, id) {
        return new Promise((resolve, reject) => {
            api.getPatient(id).then(
                (response) => {
                    commit("SET_PATIENT", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    savePatient({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            console.log("SAVING PATIENT: ", data);
            api.savePatient(data).then(
                (response) => {
                    dispatch;
                    // commit('SET_PATIENT', response)
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    deletePatient({ dispatch }, id) {
        return new Promise((resolve, reject) => {
            api.deletePatient(id).then(
                (response) => {
                    dispatch("getPatients");
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    searchPatient({ commit }, data) {
        api.searchPatient(data).then((response) => {
            commit("SET_RESULTATS", response);
        });
    },

    getHistorique({ commit }, id) {
        api.getHistorique(id).then((response) => {
            commit("SET_HISTORIQUES", response);
        });
    },

    historiqueDatePatient({ commit }, { id, data }) {
        api.historiquePatient(id, data).then((response) => {
            commit("SET_HISTORIQUES", response);
        });
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}